module.exports = __webpack_public_path__ + "resources/e614413a37093b678d900978f5c3ef1c.otf";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/TradeGothic-Italic.otf
// module id = 220
// module chunks = 0